<template>
  <div>
    <productsBreadcrumb
      v-if="$root.mode === 'xs' || $root.mode === 'sm'"
      v-bind:title="acf.category_display_name"
      pageType="listing"
    ></productsBreadcrumb>
    <section
      class="mask-full-product-list"
      resmed-component-name="masks_full_product_list"
    >
      <div class="component">
        <div class="categories">
          <div class="container">
            <h1 class="mb-2 text-center text-md-left py-4">
              {{ acf.heading }}
            </h1>
          </div>

          <!-- Show if multilevel filter is enabled -->
          <section class="multilevel-filter mb-5" v-if="acf.multilevel_filter">
            <div class="py-5 container">
              <p class="pb-2">Select category to filter</p>
              <ul class="filter">
                <li
                  class="d-md-inline-block d-block"
                  v-for="(category, i) in acf.filter_values"
                  v-bind:key="i"
                  v-bind:class="{
                    'is-active': categoryActive === category.name,
                  }"
                >
                  <a
                    href="#"
                    class="d-md-inline-block d-block"
                    v-on:click.prevent="selectCategory(category.name)"
                    >{{ category.name }}</a
                  >
                </li>
              </ul>
            </div>
          </section>

          <!-- End section -->

          <div class="container">
            <!-- <p class="mb-4">Filter by {{ acf.category_display_name }} type</p> -->
            <p class="pb-3" v-if="acf.multilevel_filter">Select product type</p>
            <p class="pb-3" v-else>
              {{ $getTranslation("Filter by", $route.params.region) }}
              <span class="text-lowercase">{{
                acf.category_display_name
              }}</span>
              {{ $getTranslation("type", $route.params.region) }}
            </p>
            <ul class="filter">
              <li
                v-for="(item, i) in categories"
                v-bind:key="i"
                v-bind:class="{ 'is-active': active === item.name }"
              >
                <a href="#" v-on:click.prevent="select(item)"
                  >{{ item.name
                  }}<span
                    >({{
                      allProducts[getSlug(item.optionValue)]
                        ? allProducts[getSlug(item.optionValue)].length
                        : 0
                    }})</span
                  ></a
                >
              </li>
            </ul>

            <h3
              class="pt-4 mb-0 text-capitalize"
              style="font-size: 2rem; line-height: 1.3;"
              v-text="
                categoryActive === 'all'
                  ? `${$getTranslation(
                      categoryActive,
                      $route.params.region
                    )} ${$getTranslation('Products', $route.params.region)}`
                  : `${$getTranslation(
                      'All',
                      $route.params.region
                    )} ${categoryActive} ${$getTranslation(
                      'Products',
                      $route.params.region
                    )}`
              "
            ></h3>
            <p v-if="productsCount > 0" class="mb-0">
              {{ $getTranslation("Displaying", $route.params.region) }}: 1 -
              {{ productsCount }}
              {{ $getTranslation("of", $route.params.region) }}
              {{ productsCount }}
              {{ $getTranslation("result(s)", $route.params.region) }}
            </p>
          </div>
        </div>

        <!-- Products -->
        <div class="stage">
          <div class="results">
            <section
              v-for="(category, i) in categories"
              class="py-5 products"
              v-if="active === category.name || active === 'All'"
              v-bind:key="i"
            >
              <div
                class="container"
                v-bind:id="getOptionsSlug(category.name, category.optionValue)"
              >
                <div class="row">
                  <div class="col-md-3">
                    <h3 style="font-weight: 600;" class="mb-4">{{ category.name }}</h3>
                    <p class="pb-3">{{ category.description }}</p>
                  </div>
                  <div class="col-md-9">
                    <div class="items row mx-0 mb-md-3">
                      <h3
                        style="font-size: 1.3rem; font-weight: 600; line-height: 1.3;"
                        class="text-center mx-auto pt-5"
                        v-if="
                          !products[
                            getOptionsSlug(category.name, category.optionValue)
                          ] ||
                            products[
                              getOptionsSlug(
                                category.name,
                                category.optionValue
                              )
                            ].length === 0
                        "
                      >
                        {{ loading ? "Loading..." : "No products found" }}
                      </h3>
                      <div
                        v-if="
                          products[
                            getOptionsSlug(category.name, category.optionValue)
                          ] &&
                            products[
                              getOptionsSlug(
                                category.name,
                                category.optionValue
                              )
                            ].length > 0 &&
                            !category.showallProducts
                        "
                        class="item col-lg-4 col-md-6 col-12"
                        v-for="(item, i) in getSlicedProducts(
                          products[
                            getOptionsSlug(category.name, category.optionValue)
                          ],
                          0,
                          6
                        )"
                        v-bind:key="i"
                      >
                        <a
                          v-on:click.capture="view(item)"
                          v-if="item.cta"
                          v-bind:href="getCategoryTranslation(item.cta.href)"
                        >
                          <div
                            class="card bg-white py-3"
                            v-bind:class="item.category"
                            @click="dataLayer(item)"
                          >
                            <div class="content row mx-0">
                              <div
                                class="col-5 product-img"
                                v-bind:style="{
                                  backgroundImage:
                                    'url(' + item.featuredImage + ')',
                                }"
                              ></div>
                              <div class="col-7">
                                <p
                                  class="discontinued mb-3"
                                  v-if="item.subCategory.includes('notinuse')"
                                >
                                  <img
                                    src="@/assets/images/discontinued-color-icon.svg"
                                  />
                                  {{
                                    $getTranslation(
                                      "DISCONTINUED",
                                      $route.params.region
                                    )
                                  }}
                                </p>
                                <p v-else class="category-name">
                                  {{ category.name }}
                                </p>
                                <h3 style="font-size: 1.3rem; font-weight: 600; line-height: 1.3;" v-html="item.title"></h3>
                                <a
                                  class="btn cta-plain text-red icon right-arrow textButtonDark"
                                  >{{
                                    $getTranslation(
                                      "Find out more",
                                      $route.params.region
                                    )
                                  }}</a
                                >
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>

                      <div
                        v-if="
                          products[
                            getOptionsSlug(category.name, category.optionValue)
                          ] &&
                            products[
                              getOptionsSlug(
                                category.name,
                                category.optionValue
                              )
                            ].length >= 6 &&
                            category.showallProducts
                        "
                        class="item col-lg-4 col-md-6 col-12"
                        v-for="(item, i) in getSlicedProducts(
                          products[
                            getOptionsSlug(category.name, category.optionValue)
                          ],
                          0
                        )"
                      >
                        <a
                          v-if="item.cta"
                          v-on:click.capture="view(item)"
                          v-bind:href="getCategoryTranslation(item.cta.href)"
                        >
                          <div
                            class="card bg-white py-3"
                            v-bind:class="item.category"
                            @click="dataLayer(item)"
                          >
                            <div class="content row mx-0">
                              <div
                                class="col-5 product-img"
                                v-bind:style="{
                                  backgroundImage:
                                    'url(' + item.featuredImage + ')',
                                }"
                              ></div>
                              <div class="col-7">
                                <p
                                  class="discontinued mb-3"
                                  v-if="item.subCategory.includes('notinuse')"
                                >
                                  <img
                                    src="@/assets/images/discontinued-color-icon.svg"
                                  />
                                  {{
                                    $getTranslation(
                                      "DISCONTINUED",
                                      $route.params.region
                                    )
                                  }}
                                </p>
                                <p v-else class="category-name">
                                  {{ category.name }}
                                </p>
                                <h3 style="font-size: 1.3rem; font-weight: 600; line-height: 1.3;" v-html="item.title"></h3>
                                <a
                                  class="btn cta-plain text-red icon right-arrow textButtonDark"
                                  >{{
                                    $getTranslation(
                                      "Find out more",
                                      $route.params.region
                                    )
                                  }}</a
                                >
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>

                      <div
                        :style="{
                          display: category.showDiscontinued ? 'none' : 'block',
                        }"
                        class="item col-lg-4 col-md-6 col-12"
                        v-if="
                          category.showallProducts ||
                            (products[
                              getOptionsSlug(
                                category.name,
                                category.optionValue
                              )
                            ] &&
                              getSlicedProducts(
                                products[
                                  getOptionsSlug(
                                    category.name,
                                    category.optionValue
                                  )
                                ],
                                0
                              ).length < 6)
                        "
                      >
                        <div
                          v-if="
                            getDiscontinuedProducts(
                              products[
                                getOptionsSlug(
                                  category.name,
                                  category.optionValue
                                )
                              ]
                            ).length
                          "
                          class="card py-3 machine"
                          style="background-color: white;"
                          v-on:click="toggleDiscontinued(category)"
                        >
                          <div
                            class=" content row mx-0 d-flex flex-column justify-content-center align-items-center"
                          >
                            <img
                              src="@/assets/images/right-arrow-black.svg"
                              alt="Show More"
                              style="height: 40px; margin-bottom: 10px;"
                            />
                            <p class="text-dark">
                              {{
                                getDiscontinuedProducts(
                                  products[
                                    getOptionsSlug(
                                      category.name,
                                      category.optionValue
                                    )
                                  ]
                                ).length
                              }}
                              {{
                                $getTranslation(
                                  "Discontinued Product(s)",
                                  $route.params.region
                                )
                              }}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="
                          getDiscontinuedProducts(
                            products[
                              getOptionsSlug(
                                category.name,
                                category.optionValue
                              )
                            ]
                          ).length && category.showDiscontinued
                        "
                        class="item col-lg-4 col-md-6 col-12"
                        v-for="(item, i) in getDiscontinuedProducts(
                          products[
                            getOptionsSlug(category.name, category.optionValue)
                          ],
                          0
                        )"
                      >
                        <a
                          v-if="item.cta"
                          v-on:click.capture="view(item)"
                          v-bind:href="getCategoryTranslation(item.cta.href)"
                        >
                          <div
                            v-if="
                              getSlicedProducts(
                                products[
                                  getOptionsSlug(
                                    category.name,
                                    category.optionValue
                                  )
                                ]
                              ).length < 6
                                ? true
                                : category.showallProducts
                            "
                            class="card bg-white py-3"
                            v-bind:class="item.category"
                          >
                            <div class="content row mx-0">
                              <div
                                class="col-5 product-img"
                                v-bind:style="{
                                  backgroundImage:
                                    'url(' + item.featuredImage + ')',
                                }"
                              ></div>
                              <div class="col-7">
                                <p
                                  class="discontinued mb-3"
                                  v-if="item.subCategory.includes('notinuse')"
                                >
                                  <img
                                    src="@/assets/images/discontinued-color-icon.svg"
                                  />
                                  {{
                                    $getTranslation(
                                      "DISCONTINUED",
                                      $route.params.region
                                    )
                                  }}
                                </p>
                                <p v-else class="category-name">
                                  {{ category.name }}
                                </p>
                                <h3 style="font-size: 1.3rem; font-weight: 600; line-height: 1.3;" v-html="item.title"></h3>
                                <a
                                  class="btn cta-plain text-red icon right-arrow textButtonDark"
                                  >{{
                                    $getTranslation(
                                      "Find out more",
                                      $route.params.region
                                    )
                                  }}</a
                                >
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>

                      <div
                        class="w-100 text-center pt-3"
                        v-if="
                          (getSlicedProducts(
                            products[
                              getOptionsSlug(
                                category.name,
                                category.optionValue
                              )
                            ],
                            0
                          ).length > 5 &&
                            getTotalCount(
                              products,
                              category.name,
                              category.optionValue
                            ).discontinuedCount > 0) ||
                            (getTotalCount(
                              products,
                              category.name,
                              category.optionValue
                            ).count > 6 &&
                              category.showDiscontinued) ||
                            (getTotalCount(
                              products,
                              category.name,
                              category.optionValue
                            ).discontinuedCount === 0 &&
                              getTotalCount(
                                products,
                                category.name,
                                category.optionValue
                              ).count > 6)
                        "
                      >
                        <button
                          class="btn ctaButton cta-pill filled-red icon right-arrow"
                          v-on:click="toggle(category)"
                        >
                          {{
                            category.showallProducts ||
                            category.showDiscontinued
                              ? $getTranslation("View Less", $route.params.region)
                              : $getTranslation("View More", $route.params.region)
                          }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <!-- End Products -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import _ from "lodash";
import { track_product_click } from "../../analytics/events";
import { scroll } from "../../mixins/index";
import wpApi from "../../services/wpApi";
export default {
  name: "product-list",
  props: ["acf"],
  mixins: [scroll],
  data() {
    return {
      init: false,
      active: "",
      categories: [],
      allcategories: [],
      colors: [],
      items: [],
      qty: {},
      products: [],
      allProducts: [],
      categoryName: "",
      categoryActive: "all",
      loading: false,
      productsCount: 0,
      options: {},
      siteRegion: "",
    };
  },
  async mounted() {
    if(this.$route.params.slug != this.$getCategoryTranslation(this.$route.params.slug, this.$route.params.region)) {
      this.$router.push({
          params: {
            name: "App",
            slug: this.$getCategoryTranslation(
              this.$route.params.slug,
              this.$route.params.region
            ),
            region: this.$route.params.region,
          },
        });
    }
    
    // Get parameters from URL
    this.findMoreUpdation();
    let path = location.pathname.substr(1).split("/");

    let type = this.options.value,
      activeCategory = this.categoryActive
        .toLowerCase()
        .split(" ")
        .join("-");
    wpApi.getProductByCategory(
      this.$route.params.region,
      this.acf.category
    )
      .then((response) => {
        this.loading = false;
        this.items = response.data.items;
        this.productsCount = this.items.length;

        if (type === "all") {
          this.products = this.items.reduce(function(items, product) {
            product.subCategory &&
              product.subCategory.forEach(function(item) {
                var name = item;
                var productbyCategory = items[name] || (items[name] = []);
                productbyCategory.push(product);
              });

            return items;
          }, {});
          this.allProducts = this.products;
        } else {
          var data = {};
          data[this.getSlug(this.options.value)] = this.items;
          this.products = data;
        }
        if (!this.init) {
          this.init = true;
          this.qty = response.data.qty;

          bus.$emit("recently-viewed:init", this.colors);
        }
      });
  },
  methods: {
    getCategoryTranslation(url) {
      const [, , , , categoryName] = url.split("/");

      const newUrl = url.replace(
        categoryName,
        this.$getCategoryTranslation(categoryName, this.$route.params.region)
      );
      return newUrl;
    },
    select(item) {
      const name = item.name === this.active ? "All" : item.name;
      const value =
        item.name === this.active
          ? "all"
          : this.getOptionsSlug(item.name, item.optionValue);

      this.options = {
        name: name,
        value: value,
      };
      this.active = name;
    },
    selectCategory(category) {
      this.categoryActive = category === this.categoryActive ? "all" : category;
    },
    view(arg) {
      if (!localStorage.getItem("recently-viewed")) {
        localStorage.setItem("recently-viewed", JSON.stringify([arg]));
      } else {
        let arr = JSON.parse(localStorage.getItem("recently-viewed"));

        let find = arr.find((el) => {
          return el.id === arg.id;
        });

        if (!find) {
          arr.unshift(arg);
        }

        localStorage.setItem("recently-viewed", JSON.stringify(arr));
      }
    },
    dataLayer(data) {
      track_product_click({
        clicked_area: "product-list",
        component_name: "product-list",
        component_variant: (this.acf && this.acf.category_display_name) || "",
        product_name: data.title,
        product_display_name: data.title,
        product_category: data.category || data.subCategory || "",
        clicked_text: data.title,
        clicked_url: data.cta ? data.cta.href : "",
      });
    },
    category(name) {
      return name
        .toLowerCase()
        .split("-")
        .join(" ");
    },
    getSlug(name) {
      return name
        .toLowerCase()
        .split(" ")
        .join("-");
    },
    getOptionsSlug(name, value) {
      if (value === "") {
        return name
          .toLowerCase()
          .split(" ")
          .join("-");
      } else {
        return value;
      }
    },
    toggle(category) {
      if (category.showallProducts) {
        this.scroll({
          to: `#${this.getSlug(category.name)}`,
        });
      }
      if (category.showDiscontinued === true) {
        this.toggleDiscontinued(category);
      }
      return (category.showallProducts = !category.showallProducts);
    },
    toggleDiscontinued(category) {
      return (category.showDiscontinued = !category.showDiscontinued);
    },
    getSlicedProducts(products, from, to) {
      let productsToShow = [];
      if (products !== undefined) {
        if (to !== undefined) {
          products.forEach((product) => {
            let subCategory = product.subCategory.includes("notinuse");
            if (!subCategory) {
              productsToShow.push(product);
            }
            productsToShow = productsToShow.slice(0, 6);
          });
        } else {
          products.forEach((product) => {
            let subCategory = product.subCategory.includes("notinuse");
            if (!subCategory) {
              productsToShow.push(product);
            }
          });
        }
        let allproducts = productsToShow;
        return allproducts;
      }
    },

    getDiscontinuedProducts(products, from) {
      let discontinuedProducts = [];
      if (products !== undefined) {
        products.slice(from).forEach((product) => {
          let subCategory = product.subCategory.includes("notinuse");
          if (subCategory) {
            discontinuedProducts.push(product);
          }
        });
        let allproducts = discontinuedProducts;
        return allproducts;
      }
    },

    getTotalCount(products, category, optionValue) {
      let count;
      let discontinuedCount;
      if (products[this.getOptionsSlug(category, optionValue)]) {
        count =
          this.getSlicedProducts(
            products[this.getOptionsSlug(category, optionValue)],
            0
          ).length +
          this.getDiscontinuedProducts(
            products[this.getOptionsSlug(category, optionValue)],
            0
          ).length;
        discontinuedCount = this.getDiscontinuedProducts(
          products[this.getOptionsSlug(category, optionValue)],
          0
        ).length;
      }
      return { count, discontinuedCount };
    },
    findMoreUpdation() {
      this.siteRegion = this.$route.params.region;
      return this.siteRegion;
    },
  },
  created() {
    let hash = window.location.hash.substring(1);
    for (let value of this.acf.categories) {
      // this.categories.push(value.name);
      let data = {};
      data["name"] = value.name;
      data["description"] = value.description;
      data["showallProducts"] = false;
      data["showDiscontinued"] = false;
      data["optionValue"] =
        value.option_value === ""
          ? this.getSlug(value.name)
          : value.option_value;
      this.categories.push(data);
    }
    this.allcategories = this.categories;
    hash = hash.charAt(0).toUpperCase() + hash.slice(1); // ucfirst
    this.active = this.categories.includes(hash) ? hash : "All";

    this.options = {
      name: "All",
      value: "all",
    };
    let siteRegion = this.$route.params.region;
  },
};
</script>

<style lang="scss">
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

// extend style
%component {
  .categories {
    margin-bottom: 1.5rem;

    @media (min-width: 768px) {
      margin-bottom: 2rem;
    }

    p {
      @extend %body-small-bold;
      font-size: 1rem;
      text-align: center;
      margin-bottom: 1rem;

      @media (min-width: 768px) {
        text-align: left;
      }
    }

    ul {
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      @media (min-width: 768px) {
        justify-content: flex-start;
      }

      li {
        margin: 0 1.25rem 1.25rem 0;

        @media (min-width: 768px) {
          margin: 0 1.25rem 1.25rem 0;
        }

        a {
          @extend %body-small-bold;
          color: #424243;
          display: inline-block;

          background-color: #dcdcdc;
          border-radius: 21px;
          padding: 0.725rem 1.75rem;
          transition: all 0.5s;

          background-repeat: no-repeat;
          background-position: 0.5rem center;
          min-width: 150px;
          text-align: center;
        }

        &.is-active {
          a {
            background-color: $cc-resmed-action-red;
            background-image: url(#{$assets}/images/icon-active-button.svg);
            color: $cc-resmed-white;
            padding-right: 1rem;
            padding-left: 2.5rem;
          }
        }
      }
    }
  }

  .stage {
    padding: 1rem 0;

    .results {
      margin-bottom: 1rem;

      h3 {
        font-size: 1.312rem;
      }
    }

    .items {
      .item {
        .card {
          position: relative;
          width: 100%;

          background-color: $cc-resmed-white;
          border-radius: 6px;
          height: 100%;

          h3 {
            color: #424243;
          }

          .category-name {
            position: relative;
            margin-bottom: 0.75rem;
            font-family: "Plus Jakarta Sans", Arial, sans-serif;
            font-size: 14px;
            color: #9e9e9e;
          }
        }

        .content {
          padding: 1rem;
          min-height: 140px;

          h3 {
            margin-bottom: 1rem;
            min-height: 56px;
            font-size: 1.175rem;
            @media (max-width: 768px) {
              font-size: 1rem;
            }
          }

          ul {
            list-style: none;
            margin-bottom: 0;

            li {
              text-indent: -1rem;
              padding-left: 1rem;

              &:before {
                content: "•";
                padding-right: calc(1rem / 2);
              }
            }
          }

          .btn {
            position: absolute;
            bottom: 0;
          }
        }
      }
    }
  }
}

// this component
.mask-full-product-list {
  padding: 2rem 0;
  animation: fade-in 2s ease;

  @media (max-width: 468px) {
    padding: 0;
  }
  @media (min-width: 992px) {
    min-height: 640px;
  }

  .component {
    @extend %component;

    .stage {
      .items {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -0.25rem;

        @media (min-width: 768px) {
          margin: 0 -0.5rem;
        }
      }

      .item {
        width: 50%;
        padding: 0.25rem;

        @media (min-width: 768px) {
          padding: 0.725rem;
          width: 33.33333%;
        }

        @media (min-width: 1200px) {
          width: 25%;
        }
      }
    }
  }
}
.products:nth-child(odd) {
  background-color: #f7f7f7;
}
.products:nth-child(even) {
  background-color: #f2f2f2;
}
.product-img {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  max-height: 125px;
}
.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(10px);
  opacity: 0;
}
.multilevel-filter {
  background-color: #eef3f9;
  .filter {
    li {
      @media (max-width: 480px) {
        width: 80%;
        margin-right: 0 !important;
      }
      a {
        border-radius: 6px !important;
        background-color: #c9d7e2 !important;
      }
      &.is-active {
        a {
          background-color: $cc-resmed-action-red !important;
          background-image: url(#{$assets}/images/icon-active-button.svg);
          color: $cc-resmed-white;
          padding-right: 1rem;
          padding-left: 2.5rem;
        }
      }
    }
  }
}

.discontinued {
  border: 2px solid #c50000;
  color: #c50000;
  padding: 2px 9px;
  border-radius: 50px;
  font-size: 10px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  width: fit-content;
}
</style>